import * as React from 'react';
import { injectIntl } from 'react-intl';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { useStreaks } from '../../shared/api/apiHooks';
import Skeleton from 'react-loading-skeleton';
import './StreakIndicator.scss';
import { addModifiers } from '../../shared/helpers';
import { Popup } from 'semantic-ui-react';

function StreakIndicatorWithoutIntl() {
  const { data } = useStreaks();
  const isTooltipDisabled = !data || data.active > 3;

  return (
    <div className="streak-indicator__container">
      <Popup
        className="tooltip-wbs streak-indicator__tooltip"
        trigger={
          <div className="streak-indicator">
            <div className="streak-indicator-icon__container">
              <div className={addModifiers('streak-indicator-icon', [data?.active ? 'active' : 'inactive'])}></div>
            </div>
            <span className="streak-indicator__text">
              <FormattedMessageHelper id="streaks.statusMessage.current.start" />
            </span>
            <strong>{data ? data?.active : <Skeleton width="2em" />}</strong>
            <span className="streak-indicator__text">
              <FormattedMessageHelper id="streaks.statusMessage.current.end" />
            </span>
          </div>
        }
        content={
          <div className="tooltip-wbs__content">
            <div className="tooltip-wbs__content-description">
              <span>Consecutive days of running simulations</span>
            </div>
          </div>
        }
        disabled={isTooltipDisabled}
        on="hover"
        hideOnScroll={true}
        position="top center"
        popperModifiers={[{ name: 'flip', enabled: true, options: { fallbackPlacements: ['bottom-start', 'top-start'] } }]}
      />

      {data && !data.active && <FormattedMessageHelper id="streaks.statusMessage.simulate" />}
    </div>
  );
}

export const StreakIndicator = injectIntl(StreakIndicatorWithoutIntl);
